/**
 * Generated bundle index. Do not edit.
 */

export {OrgChartComponent,OrgChartModule,IEmployee} from './index';

export {EmployeeComponent as ɵa} from './src/employee/employee.component';